import type { IFormxRepository, SubmissionListOptions } from '../repositories/IFormxRepository.js';
import type { FormxSubmissionEntity } from '../entities/FormxEntity.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxSubmissionsUseCase({ formxRepository }: Deps) {
  return async function listFormxSubmissions(options: SubmissionListOptions): Promise<FormxSubmissionEntity[]> {
    return formxRepository.listSubmissions(options);
  };
}
